import styled from 'styled-components';
import { ChevronDownIcon } from '@radix-ui/react-icons';

export const CollapseContainer = styled.div`
  background-color: #f6f6f6;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  margin: 16px auto;
`;

export const CollapseHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 16px 20px;
  background-color: white;
  cursor: pointer;
  user-select: none;
`;

export const CollapseTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const CollapseIcon = styled(ChevronDownIcon)<{ $isopen: boolean }>`
  transition: transform 0.3s ease;
  transform: rotate(${(props) => (props.$isopen ? '180deg' : '0deg')});
`;

export const CollapseContent = styled.div<{ $isopen: boolean }>`
  max-height: ${(props) => (props.$isopen ? 'auto' : '0px')};
  opacity: ${(props) => (props.$isopen ? 1 : 0)};
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: #fafafa;
  padding: ${(props) => (props.$isopen ? '16px 20px' : '0 20px')};
`;
